export const defaultMonthlyRevenue = 20_000
